const menuItemsAdmin = [
    {
        label : 'Dashboard',
        icon : 'dashboard',
        route : 'society.dash'
    },
    {
        label : 'Rubrica',
        icon : 'group',
        route : 'society.contacts.list'
    },
    {
        label : 'Partite',
        icon : 'football',
        route : 'society.matches'
    },
];

export default menuItemsAdmin
